module.exports = __webpack_public_path__ + "img/section1SwiperTab4.bddc5fec.png";